import { Middleware } from "@reduxjs/toolkit"
import { FormRootState } from "./formStore"
import { selectForm } from "./selectForm"
import _ from "lodash"

// this is a temporary solution until the UI builder is done and checks
// this stuff before saving form changes
// (once this is dropped, please check if getReturnedEntities
// is still necessary)
const dupeDetectMw: Middleware<{}, FormRootState> = store => next => action => {
	const prevState = store.getState()
	const prevEntities = selectForm(prevState).returnedEntities
	const result = next(action)
	const nextState = store.getState()
	const nextEntities = selectForm(nextState).returnedEntities
	if(nextEntities && (prevEntities !== nextEntities)) {
		const cidsByPromptGuid: _.Dictionary<string[]> = {}
		const titlesByPromptGuid: _.Dictionary<string> = {}
		const { persisters } = selectForm(nextState)
		if(Object.keys(nextEntities.prompt).length > 0) {
			_.forEach(persisters, (persister, cid) => {
				const proposed = persister.getProposedEntities()
				const returned = persister.persistModel?.getReturnedEntities(proposed!, nextEntities)
				if(!returned) {
					return
				}
				for(let prompt of returned.prompts) {
					if(!cidsByPromptGuid[prompt.GUID]) {
						cidsByPromptGuid[prompt.GUID] = []
					}
					cidsByPromptGuid[prompt.GUID].push(cid)
					titlesByPromptGuid[prompt.GUID] = prompt.Title
				}
			})
			let hasDupes = false
			_.forEach(cidsByPromptGuid, (cids, guid) => {
				if(cids.length > 1) {
					hasDupes = true
					console.debug('Multiple cids for prompt GUID', guid, titlesByPromptGuid[guid], cids)
				}
			})
			if(hasDupes) {
				alert('This form has multiple cids for some prompts and must be fixed by a developer.  If you proceed, data loss may occur.  (See console for details)')
			}
		}
	}
	return result
}

export default dupeDetectMw
